"use strict";

var HiddenField, React;

React = require("react");

HiddenField = React.createClass({
  displayName: "HiddenField",

  propTypes: {
    dataKey: React.PropTypes.string,
    data: React.PropTypes.any
  },
  render: function render() {
    return React.createElement("input", {
      type: "hidden",
      className: "form-control",
      name: this.props.dataKey,
      defaultValue: this.props.data,
      onChange: this.onChange
    });
  }
});

module.exports = HiddenField;


/*****************
 ** WEBPACK FOOTER
 ** ./lib/controls/Hidden.js
 ** module id = 549
 ** module chunks = 0
 **/